module.exports = __webpack_public_path__ + "campaign/partner2021-minisite-1/img/page2-right-bg.c5e4d301.png";